"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoot = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_slot_1 = require("@radix-ui/react-slot");
const getRoot = ({ asChild, children, parent: Parent, }) => {
    if (asChild) {
        let child = React.Children.only(children);
        const grandChildren = child.props.children;
        return {
            Root: ((props) => {
                child = React.cloneElement(child, {
                    children: props.children,
                });
                // Make sure we don't pass `asChild` to DOM elements
                const asChildProp = Parent === react_slot_1.Slot ? undefined : asChild;
                return (React.createElement(Parent, { asChild: asChildProp, ...props }, child));
            }),
            children: grandChildren,
        };
    }
    return {
        Root: Parent,
        children: children,
    };
};
exports.getRoot = getRoot;
//# sourceMappingURL=get-root.js.map